const Layout = () => import('@/layout/index.vue')

export default {
    path: '/agency',
    component: Layout,
    redirect: '/agency/set',
    name: 'Agency',
    meta: {
        title: '代理管理',
        icon: 'agency'
    },
    children: [
        {
            path: 'set',
            name: 'AgencySet',
            component: () => import('@/views/agency/set/index.vue'),
            meta: {
                title: '代理设置',
                icon: 'agency-set',
                auth: ['agency.set']
            }
        },
        {
            path: 'account',
            name: 'AgencyAccount',
            component: () => import('@/views/agency/account/index.vue'),
            meta: {
                title: '用户管理',
                icon: 'agency-account',
                auth: ['agency.account']
            }
        },
        {
            path: 'order',
            name: 'AgencyOrder',
            component: () => import('@/views/agency/order/index.vue'),
            meta: {
                title: '订单管理',
                icon: 'agency-order',
                auth: ['agency.order']
            }
        },
        {
            path: 'commission',
            name: 'AgencyCommission',
            component: () => import('@/views/agency/commission/index.vue'),
            meta: {
                title: '佣金流水',
                icon: 'agency-commission',
                auth: ['agency.commission']
            }
        },
        {
            path: 'withdrawLog',
            name: 'AgencyWithdrawLog',
            component: () => import('@/views/agency/withdrawLog/index.vue'),
            meta: {
                title: '提现记录',
                icon: 'agency-withdrawLog',
                auth: ['agency.withdrawLog']
            }
        },
        {
            path: 'refundLog',
            name: 'AgencyRefundLog',
            component: () => import('@/views/agency/refundLog/index.vue'),
            meta: {
                title: '退款记录',
                icon: 'agency-refundLog',
                auth: ['agency.refundLog']
            }
        }
    ]
}
